import CharactersCount from './components/CharactersCount'

import './App.css'

// Replace your code here
const App = () => <CharactersCount />

export default App
